export default {
	// #region Tab Titles
	TAB_HOME: 'Home',
	TAB_CALENDAR: 'Leave Calendar',
	TAB_AVAILABILITY: 'Availability Calendar',
	// #endregion

	// #region Home Dashboard
	VISIBLE_COMMUNICATIONS: 'Visible Communications',

	UNASSIGNED_REQUESTS: 'Unassigned Requests',
	WAITING_REQUESTS: 'Waiting Requests',
	OPEN_REQUESTS: 'Open Requests',
	CLOSED_REQUESTS: 'Closed Requests',

	UNASSIGNED_LEAVE: 'Unassigned Leave',
	WAITING_LEAVE: 'Waiting Leave',
	OPEN_LEAVE: 'Open Leave',
	CLOSED_LEAVE: 'Closed Leave',

	FAST_ACTIONS_WIDGET_TITLE: 'Fast actions',
	LINKS_WIDGET_TITLE: 'Links',

	VIEW_ITEM_BUTTON_NEW_COMMUNICATION: 'New Communication',
	VIEW_ITEM_BUTTON_NEW_REQUEST: 'New Request',
	VIEW_ITEM_BUTTON_NEW_LEAVE: 'New Leave',
	VIEW_ITEM_BUTTON_NEW_DOCUMENT_FOLDER: 'New Document Folder',
	// #endregion

	// #region Card Stats
	DASHBOARD_CARD_TITLE_OPEN_LEAVE_REQUESTS: 'Open Leave Requests',
	DASHBOARD_CARD_TITLE_ACCEPTED_LEAVE: 'Accepted Leave',
	DASHBOARD_CARD_TITLE_OPEN_REQUESTS: 'Open Requests',
	DASHBOARD_CARD_TITLE_TAKE_CHARGE_REQUESTS: 'Requests taken over',
	// #endregion

	// #region Calendar Section
	DASHBOARD_BTN_PREV: 'Previous Year',
	DASHBOARD_BTN_NEXT: 'Next Year',
	DASHBOARD_CALENDAR_VIEW: 'Leave Calendar',
	DASHBOARD_CALENDAR_REQUESTED_VIEW_SUBHEADER: 'Requested leave days',
	DASHBOARD_CALENDAR_CONFIRMED_VIEW_SUBHEADER: 'Confirmed leave days'
	// #endregion
};
